/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_ResendInputs */

const en_password_reset_resend = /** @type {(inputs: Password_Reset_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend link`)
};

const es_password_reset_resend = /** @type {(inputs: Password_Reset_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar enlace`)
};

/**
* | output |
* | --- |
* | "Resend link" |
*
* @param {Password_Reset_ResendInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_resend = /** @type {((inputs?: Password_Reset_ResendInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_ResendInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_resend(inputs)
	return en_password_reset_resend(inputs)
});